import axios from 'axios';

function parseSepaXml(file) {
	const url = `/admin/invoice/sepa-parse`;
	const form = new FormData();
	form.append('file', file);
	return axios
		.post(url, form, { headers: { 'Content-Type': 'multipart/form-data' } })
		.then((x) => x.data);
}

function mergeSepaXml(files) {
	const url = `/admin/invoice/sepa-merge`;
	const form = new FormData();
	for (const f of files) {
		form.append('files', f);
	}
	return axios
		.post(url, form, {
			headers: { 'Content-Type': 'multipart/form-data' },
			responseType: 'blob',
		})
		.then((response) => {
			const blob = new Blob([response.data], { type: 'application/xml' });
			const now = new Date();
			const y = now.getFullYear();
			const m = String(now.getMonth() + 1).padStart(2, '0');
			const d = String(now.getDate()).padStart(2, '0');
			const filename = `sepa_batch_${y}${m}${d}_${files.length}.xml`;
			const downloadUrl = window.URL.createObjectURL(blob);
			const a = document.createElement('a');
			a.href = downloadUrl;
			a.download = filename;
			document.body.appendChild(a);
			a.click();
			document.body.removeChild(a);
			window.URL.revokeObjectURL(downloadUrl);
			return true;
		})
		.catch(async (err) => {
			if (err && err.response && err.response.data instanceof Blob) {
				try {
					const text = await err.response.data.text();
					const json = JSON.parse(text);
					return Promise.reject({
						response: { data: json, status: err.response.status },
					});
				} catch (parseErr) {
					// fall through
				}
			}
			return Promise.reject(err);
		});
}

export { parseSepaXml, mergeSepaXml };
